import React, { useEffect } from "react";
import { Redirect, useLocation } from "react-router-dom";
import { StatusMessage, StatusType } from "./interfaces";

import { StyledAlert } from "App/global-style";
import { useIsAdvisorSelector } from "Store/advisor/advisorSelectors";
import { useDowntime } from "Store/downtime";
import { setPageRedirectedFromCookie } from "Utils/cookies/cookiesUtil";
import { getPrioritizedStatus } from "./utils";

type StatusRedirectProps = {
  status: StatusMessage;
};

export const StatusRedirect = ({ status }: StatusRedirectProps): null => {
  const location = useLocation();

  useEffect(() => {
    if (location && status && status.statusType === StatusType.DOWNTIME) {
      setPageRedirectedFromCookie(location?.pathname);
    }
  }, [status]);

  return null;
};

export const Status = (): React.ReactElement | null => {
  const { current: downtime } = useDowntime();
  const isAdvisor = useIsAdvisorSelector();

  const status = downtime && getPrioritizedStatus(downtime);

  if (!status) {
    return null;
  }

  if (status.statusType === StatusType.DOWNTIME) {
    return <Redirect push to="/nedetid" />;
  }

  return (
    <>
      {!isAdvisor && <StatusRedirect status={status} />}
      <StyledAlert
        marginBottom="16px"
        title={status.title}
        description={status.message}
        type="warning"
        fluid
        alertId="status"
      />
    </>
  );
};
